import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { useQuery } from '@tanstack/react-query'
import { query } from 'devextreme/common/data'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import { useMemo } from 'react'

export const ODataStoreComposer = (endpoint: string, token: string) => {
  return new ODataStore({
    url: `${import.meta.env.VITE_QSADMINAPI_HOST}/${endpoint}`,
    key: 'id',
    keyType: 'Int32',
    version: 4,
    beforeSend: ODataStoreRequestConfiguration(token),
  })
}

export const ArraySourceComposer = (key: string, list: unknown[] | undefined) => {
  return new DataSource({
    store: new ArrayStore({
      data: list,
      key,
    }),
    paginate: true,
  })
}

export const useLookupDataSource = (key: string, query: string, filter?: (item: any) => boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: ['lookupSource', query],
    queryFn: async () => {
      const response = await useQsAdminApiManager.getState().client.get(query)
      return response.data.value
    },
    refetchInterval: 60000, // 1 minute
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })

  const dataSource = useMemo(
    () =>
      new DataSource({
        store: new ArrayStore({
          key,
          data: data ?? [],
        }),
        paginate: true,
        filter,
      }),
    [data, key, filter],
  )

  return { dataSource, isLoading }
}
